import React, { FC } from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';

import Stack from '../stack/Stack';
import Html from '../html/Html';
import Typography from '../typography/Typography';
import { IconMap } from '../icon/cmsIcons';

// Interface

export interface AddressDetailsProps {
  items?: AddressDetail[];
}

export interface AddressDetail {
  heading: string;
  description: string;
  icon: 'email' | 'address';
}

// Styles

const StyledAddressDetail = styled.div`
  ${({ theme: { space, colors, media } }) => css`
    display: flex;
    gap: ${space.xxSmall};

    & + & {
      padding-top: ${space.medium};
      border-top: solid 1px currentColor;
    }
  `};
`;

// JSX

const AddressDetail: FC<AddressDetail> = ({ heading, description, icon }) => {
  let Icon = null;

  // Check that all icons are defined

  Object.entries(IconMap).forEach(([key, value]) => {
    if (!value) {
      console.error(`Icon with key ${key} is undefined.`);
    }
  });

  if (icon) {
    const normalizedIcon = icon.replace(/\s+/g, '');
    const dynamicIconKey =
      normalizedIcon.charAt(0).toUpperCase() + normalizedIcon.slice(1);
    Icon = IconMap[dynamicIconKey as keyof typeof IconMap];
  }

  return (
    <StyledAddressDetail>
      {Icon && <Icon />}
      <Stack gap="xxxSmall">
        {heading && (
          <Typography component="h3" variant="bodyLargeBold">
            {heading}
          </Typography>
        )}
        {description && <Html>{description}</Html>}
      </Stack>
    </StyledAddressDetail>
  );
};

export const AddressDetails: FC<AddressDetailsProps> = ({ items }) => (
  <Stack gap="medium">
    {items?.map((item, index) => (
      <AddressDetail key={index} {...item} />
    ))}
  </Stack>
);

export default AddressDetails;
